import RightSideMenuContainer from '../../DspNavigation/containers/RightSideMenuContainer';
import React, { FunctionComponent } from 'react';
import { Route, Switch } from 'react-router-dom';
import styled from 'styled-components';
import { ErrorMessage, } from 'UI-Dash-Commons-UI';
import ContentComponent from '../../DspNavigation/components/ContentComponent';
import LeftSideMenuContainer from '../../DspNavigation/containers/LeftSideMenuContainer';
import { DSP_DOCS_CLIENT_BASE_URL } from '../redux/constants';
import DspAlxReportingPage from './DspAlxReportingPage';
import DspDeletedDeviceIdsApiPage from './DspDeletedDeviceIdsAPIPage';
import ORTBIntroductionPage from './ORTBIntroduction';
import ORTBBidRequestPage from './ORTBBidRequest';
import ORTBBidResponsePage from './ORTBBidResponse';
import ORTBCreativeTypesPage from './ORTBCreativeTypes';
import ORTBChangelogPage from './ORTBChangelog';
import DspReportingPage from './DspReportingPage';
import DspSKAdNetworkPage from './DspSKAdNetworkPage';
import DspTestingPage from './DspTestingPage';
import DspViewabilityPage from './DspViewabilityPage';

type DspDocsComponentProps = Record<string, never>;

const DspDocsComponent: FunctionComponent<DspDocsComponentProps> = ( ) =>
{
    return <DspDocsWrapper>
        <LeftSideMenuContainer/>
        <ContentComponent>
            <Switch>
                <Route
                    exact
                    path={`${DSP_DOCS_CLIENT_BASE_URL}`}
                    component={ORTBIntroductionPage}
                />
                <Route
                    exact
                    path={`${DSP_DOCS_CLIENT_BASE_URL}/integration`}
                    component={ORTBIntroductionPage}
                />

                <Route
                    exact
                    path={`${DSP_DOCS_CLIENT_BASE_URL}/gdpr-deleted-device-ids-api`}
                    component={DspDeletedDeviceIdsApiPage}
                />

                <Route
                    exact
                    path={`${DSP_DOCS_CLIENT_BASE_URL}/ortb-spec/introduction`}
                    component={ORTBIntroductionPage}
                />
                <Route
                    exact
                    path={`${DSP_DOCS_CLIENT_BASE_URL}/ortb-spec/bid-request`}
                    component={ORTBBidRequestPage}
                />
                <Route
                    exact
                    path={`${DSP_DOCS_CLIENT_BASE_URL}/ortb-spec/bid-response`}
                    component={ORTBBidResponsePage}
                />
                <Route
                    exact
                    path={`${DSP_DOCS_CLIENT_BASE_URL}/ortb-spec/creative-types`}
                    component={ORTBCreativeTypesPage}
                />
                <Route
                    exact
                    path={`${DSP_DOCS_CLIENT_BASE_URL}/ortb-spec/changelog`}
                    component={ORTBChangelogPage}
                />

                <Route
                    exact
                    path={`${DSP_DOCS_CLIENT_BASE_URL}/alx-reporting`}
                    component={DspAlxReportingPage}
                />

                <Route
                    exact
                    path={`${DSP_DOCS_CLIENT_BASE_URL}/reporting`}
                    component={DspReportingPage}
                />

                <Route
                    exact
                    path={`${DSP_DOCS_CLIENT_BASE_URL}/testing`}
                    component={DspTestingPage}
                />

                <Route
                    exact
                    path={`${DSP_DOCS_CLIENT_BASE_URL}/skadnetwork`}
                    component={DspSKAdNetworkPage}
                />

                <Route
                    exact
                    path={`${DSP_DOCS_CLIENT_BASE_URL}/viewability`}
                    component={DspViewabilityPage}
                />

                <Route path="*">
                    <ErrorMessage
                        title={'Unable to load the current page.'}
                        subtitle={'Please try again.'}
                    />
                </Route>

            </Switch>
            <RightSideMenuContainer />
        </ContentComponent>
    </DspDocsWrapper>;
};

export default DspDocsComponent;

const DspDocsWrapper = styled.main`
  display: flex;
  flex-direction: row;
`;
